module.exports = __webpack_public_path__ + "static/media/circuit-bot.93b33507.png";